import {useQuery} from "@apollo/client";
import {useState} from "react";

import {LoadingContainer} from "@/components/placeholder/LoadingContainer";
import {shortDateTimeUser} from "@/lib/format.tsx";
import {GQL_PS_REPORT_HISTORY, PSReportHistoryResponse} from "@/lib/queries/pagespeed.ts";
import {AccountUser} from "@/lib/types/accounts";

interface ReportHistoryProps {
  checkID: number;
  user: AccountUser;
}
export const ReportHistory = ({checkID, user}: ReportHistoryProps) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const {data, loading, error} = useQuery<PSReportHistoryResponse>(GQL_PS_REPORT_HISTORY, {
    variables: {
      id: checkID,
      page: currentPage,
    },
    context: {
      noToast: true,
    },
  });
  if (error) {
    console.log(error);
    return <div className="py-3">No history available.</div>;
  }
  if (loading || !data) {
    return <LoadingContainer />;
  }

  const {results} = data.psReportHistory;
  if (!results || results.length < 1) {
    return <div className="py-3">No history available.</div>;
  }

  const {has_next_page, has_prev_page} = data.psReportHistory;

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Uptime Grade</th>
            <th>Performance Score</th>
            <th>Guidelines Score</th>
            <th>Location</th>
          </tr>
        </thead>
        <tbody>
          {results.map((h) => {
            return (
              <tr key={h.id}>
                <td>
                  <a href={`?result_id=${h.id}`}>{shortDateTimeUser(h.created_at, user)}</a>
                </td>
                <td>{h.uptime_grade}</td>
                <td>{h.performance_score != null && <span>{Math.round(h.performance_score)}%</span>}</td>
                <td>{h.best_practices_score != null && <span>{Math.round(h.best_practices_score)}%</span>}</td>
                <td>{h.monitoring_server?.location ? h.monitoring_server.location : "N/A"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="pagination">
        {has_prev_page && (
          <button
            type="button"
            className="me-3 fw-normal fs-6 btn btn-link text-decoration-none"
            onClick={() => {
              setCurrentPage(currentPage - 1);
            }}
          >
            Prev page
          </button>
        )}
        {has_next_page && (
          <button
            type="button"
            className="me-3 fw-normal fs-6 btn btn-link text-decoration-none"
            onClick={() => {
              setCurrentPage(currentPage + 1);
            }}
          >
            Next page
          </button>
        )}
      </div>
    </div>
  );
};
